import { forwardRef } from "react";
import { styled } from '@mui/system';
import { AppBar, Box, Button, Dialog, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Grid from "@mui/material/Unstable_Grid2/Grid2";


const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const IframeWrapper = styled(Box)({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
});

const ButtonsWrapper = styled(Box)({
    width: '100%'
});

const VideoModal = ({ open, handleClose, number, handleOpenBrowser, handleCloseBrowser, handleRefreshBrowser }) => {

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Terminal {number}
                    </Typography>
                    {/* <Button autoFocus color="inherit" onClick={handleClose}>
                        save
                    </Button> */}
                </Toolbar>
            </AppBar>
            <IframeWrapper sx={{}}>
                <iframe className="center" src={`https://video.espelhado.com:${number}`} title="Iframe" width='100%' height='100%' />
            </IframeWrapper>
            <ButtonsWrapper p={2}>
                <Grid container spacing={2}>
                    <Grid xs={12} md={4}>
                        <Button
                            variant="contained"
                            size='small'
                            fullWidth
                            onClick={() => handleOpenBrowser(number)}
                        >
                            Abrir navegador
                        </Button>
                    </Grid>
                    <Grid xs={12} md={4}>
                        <Button
                            variant="contained"
                            size='small'
                            color='error'
                            fullWidth
                            onClick={() => handleCloseBrowser(number)}
                        >
                            Fechar navegador
                        </Button>
                    </Grid>
                    <Grid xs={12} md={4}>
                        <Button
                            variant="contained"
                            size='small'
                            color='warning'
                            fullWidth
                            onClick={() => handleRefreshBrowser(number)}
                        >
                            Reiniciar navegador
                        </Button>
                    </Grid>
                </Grid>
            </ButtonsWrapper>
        </Dialog>
    )
}
export default VideoModal;